/**
 * Created by Administrator on 2018/10/17.
 */
//格式化时间戳 dateFormat('y-m-d h:i:s',144423424242)
const dateFormat = (fmt, ts) => {
    var date = new Date(ts);

    function pad(value) {
        return (value.toString().length < 2) ? '0' + value : value;
    }
    return fmt.replace(/([a-zA-Z])/g, function(_, fmtCode) {
        switch (fmtCode) {
            case 'y':
                return date.getFullYear();
            case 'm':
                return pad(date.getMonth() + 1);
            case 'd':
                return pad(date.getDate());
            case 'D':
                var dd = ["日", "一", "二", "三", "四", "五", "六"];
                return dd[date.getDay()];
            case 'h':
                return pad(date.getHours());
            case 'i':
                return pad(date.getMinutes());
            case 's':
                return pad(date.getSeconds());
        }
    });
}
const errorMessage = (error, vue) => {
    let msg = (error.body && error.body.error_code) || error.statusText || error
    vue.$message.error(msg)
}
export {dateFormat, errorMessage}


// WEBPACK FOOTER //
// ./src/util/index.js